import React from 'react';
import { FlameIcon } from 'lucide-react';
interface ScarcityBarProps {
  tone?: 'dark' | 'light';
  spotsLeft?: number;
}
export function ScarcityBar({
  tone = 'light',
  spotsLeft = 9
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto w-full max-w-sm" data-id="element-51" data-mp="2l2tpcdc7hbm0">
      <div className="flex items-center justify-between gap-2" data-id="element-52" data-mp="2q37p783nlf8y">
        <p className={`flex items-center gap-1.5 text-[11.5px] font-bold uppercase tracking-[0.1em] ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-53" data-mp="2q1oahlxnbc9a">
          <FlameIcon aria-hidden="true" className="h-3.5 w-3.5 text-orange-500" data-id="element-54" data-mp="2g3qn10nm1jhq" />
          Only {spotsLeft} spots left
        </p>
        <p className={`text-[11.5px] font-semibold ${isDark ? 'text-brand-100' : 'text-ink-500'}`} data-id="element-55" data-mp="274n01llbojxy">
          91% claimed
        </p>
      </div>
      <div className={`mt-2 h-2.5 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-navy-900/10'}`} role="img" aria-label={`91% of the promotional spots have been claimed. Only ${spotsLeft} spots remain at this price.`} data-id="element-56" data-mp="5diaqw6v3vgs">
        <div className="h-full w-[91%] rounded-full bg-orange-500" data-id="element-57" data-mp="3dcoixlyqfsai" />
      </div>
      <p className={`mt-2 text-center text-[11.5px] font-medium ${isDark ? 'text-brand-100' : 'text-ink-500'}`} data-id="element-58" data-mp="3desk3w58yd73">
        {spotsLeft} spots remain at the promotional price of $27.
      </p>
    </div>;
}